import { Component, OnInit } from '@angular/core';
import { AppConfigService } from './../../../services/app.config.service';
import { SEOService } from './../../../services/seo.service';

@Component({
  selector: 'bpc-projektfinanzierung',
  templateUrl: './projektfinanzierung.component.html',
  styleUrls: ['./projektfinanzierung.component.scss']
})
export class ProjektfinanzierungComponent implements OnInit {

  branding: string;

  constructor(private cs: AppConfigService, private seo: SEOService) {
    this.branding = cs.getBranding();
  }

  ngOnInit() {
    this.seo.createLinkForCanonicalURL();
    this.seo.setPageTitle('Projektfinanzierung - Bau- & Projektfinanzierungs-Center');
    this.seo.setMetaDesc('Finanzierung von PV Anlagen allein auf das Projekt abgestellt, auch für neu gegründete Kapitalgesellschaften, deutschlandweit, Laufzeit 18 Jahre.');
  }

}
